import {MuWidget} from "mu-widget/lib/MuWidget";
import {getBuSubjectName, getDocumentName, getOrgProjectName, UiDms} from "./UiDms";
import {EntityType} from "../Types";
import {BuSubject, DmsDocument, DocumentListPreviewOpt, documentListPreviewOpts, OrgProject} from "./Types";
import {ColumnInfo, UiTable, UiTableCell} from "../components/UiTable";

export class UiDocumentListPreview extends MuWidget<UiDms>
{
	// @ts-ignore
	public opts: DocumentListPreviewOpt;
	// @ts-ignore
	public entityType: EntityType;
	// @ts-ignore
	private entityId: number;

	beforeIndex() {
		super.beforeIndex();
		this.muAppendContent(`
			<div mu-keybind="Escape:btCloseModal">
				<div mu-bind="types:@foreach" style="display: none" mu-id="types">
					<div mu-template="item" mu-widget="UiDocumentListPreviewTypeGroup">
						<div class="display-flex" mu-id="typeInfo">
							<h3 mu-bind="name" class="flex-grow-1"></h3>
							<span class="btn btn-link icon-before-add" mu-id="bAddDocument">Přidat <span mu-bind="name"></span></span>						
						</div> 
						<table mu-id="documents" mu-widget="UiTable" class="table table-hover table-striped">
							<tr><td mu-template="actions" mu-widget="UiDocumentListPreviewOpenLink"></td></tr>
						</table>
					</div>
				</div>
				<table class="table table-hover table-striped" mu-id="fullTable">
					<thead mu-template="rowWrapper" mu-widget="."><tr><td colspan="10" mu-id="content"></td></tr></thead>
				</table>
				<span class="btn btn-link icon-before-add" mu-id="bAddDocument">Přidat jiný dokument</span>		
			</div>
		`);
	}

	public async showFor(entityType: EntityType, entityId: number, entityData: BuSubject|OrgProject|DmsDocument)
	{
		this.entityType = entityType;
		this.entityId = entityId;
		this.opts = documentListPreviewOpts[entityType];
		// titulek okna
		let entityLabel = "";
		switch (entityType) {
			case "BuSubject":
				entityLabel = getBuSubjectName(entityData);
				break;
			case "Parent":
				entityLabel = getDocumentName(entityData);
				break;
			case "OrgProject":
				entityLabel = getOrgProjectName(entityData);
				break;
		}

		this.ui.modalTitle.innerText = this.opts.label + " " + entityLabel;

		const data = await this.muParent.cl.allDocuments(
			{
				[this.opts.filterField]: entityId
			},
			{ field: "evidenceUid", dir: "asc"},
			0, null
		);
		const byType: any = {};
		for (const doc of data.list) {
			const k = doc.parentId?.dmsDocumentTypeId || doc.dmsDocumentTypeId.id;
			if (!byType[k]) {
				byType[k] = {
					name: doc.dmsDocumentTypeId.name,
					canCreate: !doc.dmsDocumentTypeId.mustHaveParent,
					dmsDocumentTypeId: doc.dmsDocumentTypeId.id,
					documents: []
				};
			}
			byType[k].documents.push(doc);
		}
		this.muBindData({ types: Object.values(byType) });
		// Do jedné tabulky
		for(const wType of this.muGetChildWidgets('types')) {
			const infoCW = this.muWidgetFromTemplate('rowWrapper', 'fullTable');
			infoCW.ui.content.appendChild(wType.ui.typeInfo);
			for(const ch of Array.from(wType.ui.documents.children)) {
				// @ts-ignore
				if (!ch.innerText.trim()) continue;
				this.ui.fullTable.appendChild(ch);
				console.log(ch);
			}
		}
	}

	bAddDocument_click() {
		this.openNew();
	}

	public openNew(data: any = {}) {
		this.muParent.openDmsDocumentEditor(null, {
			[this.opts.filterField]: this.entityId,
			...data
		})

	}

}

export class UiDocumentListPreviewTypeGroup extends MuWidget<UiDocumentListPreview, {}, {
	documents: UiTable,
}>
{
	protected allColumnInfos = [
		// new ColumnInfo({field: "id", name: "ID", filterable: false}),
		// new ColumnInfo({field: "dmsDocumentTypeId", name: "Typ", template: "shared:tdLink", widgetParams: { showCode: false }}),
		new ColumnInfo({field: "evidenceUid", name: "Naše Evč", orderable: false, filterable: false}),
		new ColumnInfo({field: "dmsDocumentClassId", name: "Druh", template: "shared:tdLink", orderable: false, filterable: false}),
		new ColumnInfo({field: "name", name: "Název", orderable: false, filterable: false}),
		// new ColumnInfo({field: "buSubjectId", name: "Náš subjekt", template: "shared:tdLink", orderable: false, filterable: false}),
		new ColumnInfo({field: "partnerBuSubjectId", name: "Druhý subjekt", template: "shared:tdLink", orderable: false, filterable: false}),
		new ColumnInfo({field: "orgDivisionId", name: "Středisko", template: "shared:tdLink", orderable: false, filterable: false}),
		new ColumnInfo({field: "orgProjectId", name: "Projekt", template: "shared:tdLink", orderable: false, filterable: false}),
		new ColumnInfo({field: "stateId", name: "Stav", template: "shared:tdLink", orderable: false, filterable: false, widgetParams: { showCode: false }}),
		// new ColumnInfo({field: "date", name: "Datum", transformContent: formatCellDate}),
		// new ColumnInfo({field: "dateFrom", name: "Datum platnosti od"}),
		// new ColumnInfo({field: "dateTo", name: "Datum platnosti do"}),
		// new ColumnInfo({field: "dateProlong", name: "Datum prodloužení"}),
		// new ColumnInfo({field: "dateProlongChangeTerm", name: "Termín změny"}),
		// new ColumnInfo({field: "responsible", name: "Odpovědná osoba", template: "shared:tdAmountCurrency"}),
		// new ColumnInfo({field: "parent", name: "Nařazený dokument"}),
		// new ColumnInfo({field: "amount", name: "Částka", template: "shared:tdAmountCurrency", headCssClass: 'number', orderable: false, filterable: false}),
		new ColumnInfo({field: "id", name: "-", template: "ancestor:actions", orderable: false, filterable: false}),
	];
	// @ts-ignore
	private dmsDocumentTypeId: number;

	afterIndex() {
		super.afterIndex();
		const cols = [];
		for(const col of this.allColumnInfos) {
			// if (col.field != this.muParent.entityType && col.field != this.muParent.entityType + "Id") cols.push(col);
			if (col.field != this.muParent.opts.filterField) cols.push(col);
		}
		this.muNamedWidget.documents.columns = cols;
	}

	protected muAfterBindData(data: any) {
		this.muNamedWidget.documents.data = data.documents;
		this.muNamedWidget.documents.render();
		this.dmsDocumentTypeId = data.dmsDocumentTypeId;
		this.muVisible(data.canCreate, "bAddDocument");
	}

	bAddDocument_click() {
		this.muParent.openNew({ dmsDocumentTypeId: this.dmsDocumentTypeId });
	}
}

export class UiDocumentListPreviewOpenLink extends UiTableCell
{
	// @ts-ignore
	private id: number;
	protected dmsDocument: DmsDocument;
	beforeIndex() {
		this.muAppendContent(`
			<span class="a whitespace-nowrap icon-before-edit" mu-id="edit">Upravit</span>
			<span class="a whitespace-nowrap icon-before-document-dir" mu-id="attaches">Přílohy</span>
		`);
	}

	render(value: any, row: any) {
		this.id = value;
		this.dmsDocument = row;
	}

	edit_click() {
		UiDms.instance.openDmsDocumentEditor(this.id);
	}

	attaches_click() {
		UiDms.instance.openAttaches(this.dmsDocument);
	}
}